// extracted by mini-css-extract-plugin
export default {"container":"zY-z","list":"AY-z"};